import { Box, styled } from "@mui/material";
import sanitizeHtml from "sanitize-html";
import portalSettingsManager from "utils/portalSettingsManager";

const Container = styled(Box)({
  "& a": {
    textDecoration: "underline",
    color: "#0000EE",
  },
});

export const RenderHTML = ({
  content,
  className,
}: {
  content: string;
  className?: string;
}): React.ReactElement => {
  if (!content) return <></>;
  const cleanHtml = sanitizeHtml(content, {
    allowedTags: portalSettingsManager.htmlSanitizerSettings.tags,
    allowedAttributes: portalSettingsManager.htmlSanitizerSettings.attributes,
  });
  return (
    <Container
      className={className}
      dangerouslySetInnerHTML={{
        __html: cleanHtml,
      }}
    />
  );
};
